import { DashboardContainer, ElementContainer } from './styles'

import Toast from 'components/Toast'
import { useFintalkCloud } from 'contexts/FintalkCloud/fintalkCloudContext'
import { FlowProvider } from 'contexts/Flow/flowContext'
import FintalkCloudSidebar from './FintalkCloudSidebar'

export function FintalkCloud() {
  const { currentElementName, getCurrentElement } = useFintalkCloud()

  return (
    <FlowProvider>
      <DashboardContainer>
        <Toast />

        <ElementContainer>
          <FintalkCloudSidebar />
          {getCurrentElement[currentElementName]}
        </ElementContainer>
      </DashboardContainer>
    </FlowProvider>
  )
}
